import { render, staticRenderFns } from "./VendorSignupForStripe.vue?vue&type=template&id=b20ca46a&scoped=true"
import script from "./VendorSignupForStripe.vue?vue&type=script&lang=js"
export * from "./VendorSignupForStripe.vue?vue&type=script&lang=js"
import style0 from "./VendorSignupForStripe.vue?vue&type=style&index=0&id=b20ca46a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20ca46a",
  null
  
)

export default component.exports